export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14418.674f4a45.jpg";